"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupExtractor = exports.propExpander = exports.groupAnnotatedAstByTag = exports.generateCssFromAst = exports.tokenizeProp = void 0;
var shorthand_expand_config_1 = require("./shorthand-expand-config");
var css_tree_1 = require("css-tree");
function tokenizeProp(value) {
    return (0, css_tree_1.parse)(value, { context: 'value' });
}
exports.tokenizeProp = tokenizeProp;
function generateCssFromAst(value) {
    return (0, css_tree_1.generate)(value);
}
exports.generateCssFromAst = generateCssFromAst;
/*
receives an annotated css ast and returns an array of groups sorted by classification (annotation)
 */
function groupAnnotatedAstByTag(ast) {
    var groups = [];
    ast.children &&
        ast.children.forEach(function (child) {
            var classification = child.classification;
            if (child.type === 'WhiteSpace' || child.type === 'Operator') {
                return;
            }
            if (classification === undefined) {
                groups.push({ nodes: [child] });
            }
            else {
                var nodeGroup = groups.find(function (group) { return group.classification === classification; });
                if (nodeGroup) {
                    // Node group exists
                    nodeGroup.nodes.push(child);
                }
                else {
                    groups.push({ nodes: [child], classification: classification });
                }
            }
        });
    return groups;
}
exports.groupAnnotatedAstByTag = groupAnnotatedAstByTag;
/*
expands a css prop using internal logic (non-browser dependent), if a config entry is available for that prop
 */
function propExpander(prop, value) {
    var matchingProp = shorthand_expand_config_1.cssGrouperConfig.find(function (expand) {
        return expand.prop === prop;
    });
    if (matchingProp === undefined) {
        return undefined;
    }
    var node = tokenizeProp(value);
    var annotatedAst = matchingProp.annotate(node);
    var groups = groupAnnotatedAstByTag(annotatedAst);
    var declarationMap = groupExtractor(groups);
    if (matchingProp.transform !== undefined) {
        return matchingProp.transform(declarationMap);
    }
    else {
        return declarationMap;
    }
}
exports.propExpander = propExpander;
/*
Extracts DeclarationMap from annotated css groups by just joining all the values
 */
function groupExtractor(groups) {
    var result = {};
    groups.forEach(function (group) {
        if (group.classification !== undefined) {
            var prop_1 = [];
            group.nodes.forEach(function (part) {
                prop_1.push(generateCssFromAst(part));
            });
            result[group.classification] = prop_1.join(' ');
        }
    });
    return result;
}
exports.groupExtractor = groupExtractor;
//# sourceMappingURL=shorthand-expand-utils.js.map